// JSON-LD for the `static_page` surface — covers all simple brand /
// legal pages (about, blog, privacy, terms, risk, social, launchpad,
// portfolio).
//
// Schema choice: WebPage. Generic and appropriate for informational
// pages with no transactional intent. Pages that need richer schemas
// (FAQ, ItemList) compose them on top via their own surface helper —
// see `surfaces/about.ts` for the pattern.

import type { ShareSurface } from '@/lib/share/events';

import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildStaticPageJsonLd(
  _surface: Extract<ShareSurface, { kind: 'static_page' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${ctx.pageUrl}#webpage`,
    url: ctx.pageUrl,
    name: ctx.name ?? 'Morfi Markets',
    ...(ctx.description !== undefined ? { description: ctx.description } : {}),
    primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
    isPartOf: { '@id': websiteId() },
    publisher: { '@id': organizationId() },
  };
}
